import { render, staticRenderFns } from "./COrderListModal.vue?vue&type=template&id=4e8fd2d5&scoped=true"
import script from "./COrderListModal.vue?vue&type=script&lang=ts"
export * from "./COrderListModal.vue?vue&type=script&lang=ts"
import style0 from "./COrderListModal.vue?vue&type=style&index=0&id=4e8fd2d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fd2d5",
  null
  
)

export default component.exports